'use client'

// R2 wave 2: counts per-user per-path content views for "continue where you left off".
// Mounted once in the provider stack; watches route changes and fires the RPC for
// signed-in users only. PostHog keeps the raw event firehose — this is ONLY the
// personalization aggregate (migration-spec/12 boundary).
import { useEffect, useRef } from 'react'
import { usePathname } from 'next/navigation'
import { useSupabaseAuth } from '@/context/supabaseContext'
import { recordView } from '@/lib/supabase/engagement'

export function ViewTracker() {
  const pathname = usePathname()
  const { user, isLoaded } = useSupabaseAuth()
  const lastRecorded = useRef<string | null>(null)

  useEffect(() => {
    if (!isLoaded || !user || !pathname) return
    if (lastRecorded.current === pathname) return
    lastRecorded.current = pathname
    void recordView(pathname)
  }, [pathname, user, isLoaded])

  return null
}
